import React from 'react';
import '../css/contact.css';
import { Helmet, HelmetProvider } from '@dr.pogodin/react-helmet';

const Contact = () => (
  
  <div className="container mt-1">
      <HelmetProvider>
    <Helmet>
    <title>İletişim | Boduroğlu Otomotiv</title>
    <meta
      name="description"
      content="Boduroğlu Otomotiv ile iletişime geçin. Adres, telefon ve e-posta bilgilerimiz burada."
    />
    <meta
      name="keywords"
      content="boduroğlu otomotiv iletişim, kadosan oto servis, dudullu araç servisi, telefon, e-posta, adres"
    />
    <meta property="og:title" content="İletişim | Boduroğlu Otomotiv" />
    <meta
      property="og:description"
      content="Dudullu Kadosan'daki oto servisimizle iletişime geçin. Adres, telefon ve e-posta bilgilerimiz burada."
    />
    <meta property="og:url" content="https://bodurogluoto.com/iletisim" />
    <meta property="og:type" content="website" />
    <meta property="og:image" content="https://bodurogluoto.com/logo.png" />
   </Helmet>
  </HelmetProvider>
    <h2 className="display-4 text-center mb-4">İletişim</h2>

    <div className="row">
      <div className="col-md-4 mb-3">
        <div className="card shadow-sm">
          <div className="card-header">
            <h5 className="mb-0">
              <i className="fa fa-map-marker-alt me-2"></i>Adres
            </h5>
          </div>
          <div className="card-body">
            <p>
              <a
                href="https://maps.app.goo.gl/mR1o4N7nY3vACoXk8"
                target="_blank"
                className="text-decoration-none"
                rel="noopener noreferrer"
              >
                Dudullu OSB, Kadosan Oto Sanayi Sitesi No:6 H Blok No, 34775 Ümraniye/İstanbul
              </a>
            </p>
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3011.3890088083103!2d29.18029977642447!3d40.994858020250454!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cacf31d8f67283%3A0x31d733b0650432f7!2sBoduro%C4%9Flu%20otomotiv%20mekanik%20servis!5e0!3m2!1str!2str!4v1744099552904!5m2!1str!2str"
              title="Boduroğlu Otomotiv Konum"  
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>

      <div className="col-md-4 mb-3">
        <div className="card shadow-sm">
          <div className="card-header">
            <h5 className="mb-0">
              <i className="fa fa-phone-alt me-2"></i>Telefon
            </h5>
          </div>
          <div className="card-body">
            <p>
              <a href="tel:+905545996888" className="text-decoration-none phone-link">
                <i className="fa fa-phone-alt"></i> 0554 599 68 88
              </a>
            </p>
          </div>
        </div>
      </div>

      <div className="col-md-4 mb-3">
        <div className="card shadow-sm">
          <div className="card-header">
            <h5 className="mb-0">
              <i className="fa fa-envelope me-2"></i>E-Posta
            </h5>
          </div>
          <div className="card-body">
            <p>
              <a href="mailto:iletisim@bodurogluoto.com" className="text-decoration-none email-link">
                <i className="fa fa-envelope me-2"></i> iletisim@bodurogluoto.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Contact;
